import { useSearchParams, useParams } from 'react-router-dom';

export function useRouteParams<T extends string | Record<string, string | undefined>>() {
	return useParams<T>();
}

type NavOptions = {
	// replace the current entry in the history stack instead of adding a new one
	replace?: boolean;
};

/**
 * A hook to get and set URL search parameters for the current route.
 *
 * @returns A tuple containing the current URLSearchParams and a function to update them.
 */
export function useRouteSearchParams(): [URLSearchParams, (newParams: URLSearchParams, options?: NavOptions) => void] {
	return useSearchParams();
}
